import { atom } from 'recoil'
import { UserState } from './useLoadUserState'

export const currentUserState = atom<UserState | undefined>({
  default: undefined,
  key: 'currentUserState',
})
